// @flow

// $FlowFixMe
import React, { lazy, Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { dataForGraphTableUsers, type InsightsNameSpoofList } from './dataTypesAndUtils';

import Button from 'ui/atoms/Button';
import Loading from 'ui/atoms/Loading';
import BlockHeader from 'ui/molecules/BlockHeader';
import ContentBlock from 'ui/molecules/ContentBlock';
import Drawer from 'ui/molecules/Drawer';
import PlaceholderStackedGraphTable from 'ui/molecules/PlaceholderStackedGraphTable';
import StackedGraphTable from 'ui/molecules/StackedGraphTable';
import withDataHandler from 'utils/withDataHandler';

const TopSpoofedUsersDetailsTable = lazy(() => import('./TopSpoofedUsersDetailsTable'));

type Props = {
  data: InsightsNameSpoofList[],
  error: boolean,
  insightsError: boolean,
  insightsLoading: boolean,
  loading: boolean,
  setFetchData: Function,
  topNames: Object,
};

const GraphTableWithDataHandler = withDataHandler({
  empty: <PlaceholderStackedGraphTable />,
})(StackedGraphTable);

export default function TopSpoofedUsers({
  data,
  error,
  insightsError,
  insightsLoading,
  loading,
  setFetchData,
  topNames,
}: Props) {
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation('email');

  const handleClick = () => {
    if (data.length > 0) setOpenModal(true);
    setFetchData(true);
  };

  return (
    <ContentBlock
      top={
        <>
          <BlockHeader
            title={t('topSpoofedUsers')}
            action={<Button disabled={data.length === 0} icon="hamburger" muted onClick={handleClick} />}
          />
          <GraphTableWithDataHandler
            data={dataForGraphTableUsers(data)}
            dataTestId="graph-table-spoofed-users"
            isEmpty={() => loading || error || data.length === 0}
            loading={loading}
            sortOtherLast
            tint="sulu"
          />
          <Drawer.Modal
            visible={openModal}
            onClose={() => {
              setOpenModal(false);
            }}
            size="large"
            paddedSides={false}
          >
            <Suspense fallback={<Loading />}>
              {openModal && (
                <TopSpoofedUsersDetailsTable
                  data={topNames}
                  insightsError={insightsError}
                  insightsLoading={insightsLoading}
                />
              )}
            </Suspense>
          </Drawer.Modal>
        </>
      }
    />
  );
}
